import * as types from './type';

import { Coupon }  from  '../../services/coupon';

export function validateCoupon(data) {
    return {
      type: types.VALIDATE_COUPON,
      payload: Coupon.validateCoupon(data),
    };
};